import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {UseSelectedBeneficiaryStoreType} from './types';

export const useSelectedBeneficiaryStore = create(
	persist<UseSelectedBeneficiaryStoreType>(
		set => ({
			selectedBeneficiary: undefined,
			setSelectedBeneficiary: beneficiary => set({selectedBeneficiary: beneficiary}),
			resetSelectedBeneficiary: () => set({selectedBeneficiary: undefined}),
		}),
		{
			name: 'selectedBeneficiary',
		},
	),
);
